<div class="settings-permissions">
  <andor-settings-shell [title]="'App Permissions' | translate">
    @let permissions = permissionStore.editAppPermissions$ | async;
    @if (permissions) {
      <div class="content">
        <andor-fieldset>
          <div class="select-role-container {{ mode() }}">
            <andor-select-field
              [options]="roleOptions()"
              [(selectedOption)]="selectedRoleOption"
              (selected)="selectRole($event)"></andor-select-field>
            <andor-icon-btn
              class="toggle-default"
              [tooltip]="'Make this the default team' | translate"
              (clickHandler)="toggleDefault()"
              [disabled]="loading() || mode() === 'create' || !!selectedRole()?.default">
              @if (selectedRole()?.default) {
                <fa-icon [icon]="faStar"></fa-icon>
              } @else {
                <fa-icon [icon]="faStarRegular"></fa-icon>
              }
            </andor-icon-btn>
            <andor-icon-btn
              class="add"
              (clickHandler)="newRole()"
              [tooltip]="'Create a new team' | translate"
              [disabled]="loading()">
              <fa-icon [icon]="faAdd"></fa-icon>
            </andor-icon-btn>
            <andor-icon-btn
              class="remove"
              (clickHandler)="deleteRole()"
              [tooltip]="'Remove the team' | translate"
              [disabled]="!!selectedRole()?.default">
              <fa-icon [icon]="faMinus"></fa-icon>
            </andor-icon-btn>
          </div>
        </andor-fieldset>
        @if (error()) {
          <andor-fieldset>
            <div class="notification error">
              <div class="text">
                {{ error() }}
              </div>
              <andor-icon-btn (click)="error.set(null)">
                <fa-icon [icon]="faClose"></fa-icon>
              </andor-icon-btn>
            </div>
          </andor-fieldset>
        }
        @if (errorNoRoles()) {
          <andor-fieldset>
            <div class="notification error">
              <div class="text">
                {{ errorNoRoles() }}
              </div>
              <andor-button class="update" (click)="getRoles()">
                {{ 'Retry' | translate }}
              </andor-button>
              <andor-icon-btn (click)="errorNoRoles.set(null)">
                <fa-icon [icon]="faClose"></fa-icon>
              </andor-icon-btn>
            </div>
          </andor-fieldset>
        }
        @if (success()) {
          <andor-fieldset>
            <div class="notification success">
              <div class="text">
                <fa-duotone-icon class="success" [icon]="faCheckCircle"></fa-duotone-icon>
                {{ success() }}
              </div>
              <andor-icon-btn (click)="success.set(null)">
                <fa-icon [icon]="faClose"></fa-icon>
              </andor-icon-btn>
            </div>
          </andor-fieldset>
        }
        @if (recovery.recoveredRole(); as recovered) {
          <andor-fieldset>
            <andor-notice
              variant="warning"
              [dismissible]="true"
              (dismissed)="recovery.clearRecoveredRole()">
              {{
                'You signed in via a recovery link — set a new password for the team "[role]" now. The old password still works until you change it.'
                  | translate: { role: recovered.name }
              }}
            </andor-notice>
          </andor-fieldset>
        }
        <andor-fieldset>
          <andor-tabs [tabs]="tabs" [(active)]="activeTab"></andor-tabs>
        </andor-fieldset>
        @if (activeTab().id === 'team-permissions') {
          <andor-fieldset>
            <div class="create-role-permissions-container">
              @if (selectedRole(); as role) {
                <andor-create-role
                  [privileges]="role.privileges"
                  [isDefaultRole]="!!role.default"
                  (changed)="updatePrivileges(role, $event)"></andor-create-role>
              }
            </div>
          </andor-fieldset>
        } @else {
          <andor-fieldset>
            <andor-text-field
              [formControl]="roleNameControl"
              [label]="'Name of the new Team' | translate"
              [labelTooltip]="'The name of the team' | translate"
              [errorMessages]="{
                required: 'The team name is required.' | translate,
                minlength: 'The team name must be at least 4 characters long.' | translate,
                maxlength: 'The team name must not exceed 20 characters.' | translate,
              }"></andor-text-field>
            @if (mode() === 'create' || !selectedRole()?.default) {
              <andor-password-confirm-inputs
                #passwordForm
                [password]="newPassword()"
                (changed)="newPassword.set($event)"
                (touched)="newPasswordTouched.set($event)"
                (valid)="newPasswordValid.set($event)"
                [labelConfirmPassword]="'Confirm Password' | translate"
                [labelPassword]="
                  (mode() === 'edit' ? 'Update Team Password' : 'Team Password') | translate
                "></andor-password-confirm-inputs>
            } @else {
              <andor-notice variant="info">
                {{
                  'The default team has no password — everyone gets it automatically.' | translate
                }}
              </andor-notice>
            }
          </andor-fieldset>
        }
      </div>
    }
    @if (permissions) {
      <div #actions actions class="actions">
        @if (mode() === 'create') {
          <andor-button
            class="add {{ roleNameControl.valid && newPasswordValid() ? '' : 'invalid' }}"
            [disabled]="!roleNameControl.valid || !newPasswordValid() || loading()"
            (click)="createRole()">
            {{ 'Add role' | translate }}
          </andor-button>
          <andor-button class="cancel" (click)="selectDefaultRole()">
            {{ 'Cancel' | translate }}
          </andor-button>
        } @else {
          <andor-button
            class="update"
            [disabled]="(newPasswordTouched() && !newPasswordValid() && !hasChanged()) || loading()"
            (click)="updateRole()">
            {{ 'Save' | translate }}
          </andor-button>
          <andor-button class="cancel" (click)="resetCurrentRole()">
            {{ 'Cancel' | translate }}
          </andor-button>
        }
      </div>
    }
    @if (!permissions) {
      <div class="login-container">
        <div class="login">
          @if (appService.authenticationState() === 'logged-in') {
            <span>{{ 'You are not eligible to edit the permissions.' | translate }}</span>
          } @else {
            <andor-simple-login></andor-simple-login>
          }
        </div>
      </div>
    }
  </andor-settings-shell>
</div>
